import React, {useState, useEffect} from 'react';
import {Form, Button, Spinner} from "react-bootstrap";
import axios from "axios";
import {useNavigate, useParams} from "react-router-dom";
import {useSelector} from "react-redux";

const QuarterlyInspectionSystemUpdate = () => {

    let navigate = useNavigate();
    // const [address, setAddress] = useState()

    const [client, setClient] = useState()
    const [useId, setId] = useState()

    const [doneSubmitting, setDoneSubmitting] = useState(false)

    const [inspection_date, set_inspection_date] = useState('')
    const [inspected_by, set_inspected_by] = useState('')
    const [system_readings, set_system_readings] = useState('')
    const [comments, set_comments] = useState('')

    const { id } = useParams();
    const userLogin = useSelector(state => state.userLogin);
    const {userInfo} = userLogin;

    let redirect = ''
    if (userInfo){
        if (userInfo.group === "AdminSuper"){
            redirect = '/inspections_dash'
        } else if (userInfo.group === "Finance") {
            redirect = '/finance_active_work_orders'
        } else if (userInfo.group === "Logistics") {
            redirect = '/logistics_dash'
        } else if (userInfo.group === "Tech") {
            redirect = '/tech_work_orders'
        }
    }


    const getBuildingAndSystem = async () => {
        const { data } = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/quarterly_inspection_systems/${id}/`, {
        // const { data } = await axios.get(`http://127.0.0.1:8000/api/quarterly_inspection_systems/${id}/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        });

        // console.log(data)
        set_inspection_date(data.inspection_date)
        set_inspected_by(data.inspected_by)
        set_system_readings(data.system_readings)
        set_comments(data.comments)


        setId(data.id)
        setClient(data.client)
    }
    // console.log(building_name)

    useEffect(() => {
        getBuildingAndSystem();
    }, [])

    const UpdateBuildingAndSystem = async () =>{
        setDoneSubmitting(true)
        let formField = new FormData()
        formField.append('client', client)

        formField.append('inspection_date',inspection_date)
        formField.append('inspected_by',inspected_by)
        formField.append('system_readings',system_readings)
        formField.append('comments',comments)

        await axios({
            method: 'PUT',
            url: `https://homesafetysolutions.pythonanywhere.com/api/quarterly_inspection_system/update/${useId}/`,
            // url: `http://127.0.0.1:8000/api/quarterly_inspection_system/update/${useId}/`,
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            },
            data: formField,
        }).then(() => {
            // console.log(response.data)
            // console.log(Error)
            navigate(redirect)
        })
        setDoneSubmitting(false)
    }

    return (
        <div className={"banner_heading"}>

            <h1>Update Quarterly Inspection Readings</h1>

            <Form>

                <Form.Group controlId={'inspection_date'}>
                    <Form.Label>Inspection Date:</Form.Label>
                    <Form.Control
                        type={'date'}
                        value={inspection_date}
                        onChange={(e) => set_inspection_date(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId={'inspected_by'}>
                    <Form.Label>Inspected By</Form.Label>
                    <Form.Control
                        type={'text'}
                        value={inspected_by}
                        onChange={(e) => set_inspected_by(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId={'system_readings'}>
                    <Form.Label>System Readings</Form.Label>
                    <Form.Control
                        type={'text'}
                        value={system_readings}
                        onChange={(e) => set_system_readings(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId={'comments'}>
                    <Form.Label>Comments</Form.Label>
                    <Form.Control
                        type={'text'}
                        value={comments}
                        onChange={(e) => set_comments(e.target.value)}
                    />
                </Form.Group>

                <br/>
                {
                    doneSubmitting
                        ?
                        (
                            <span>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Loading...
                            </span>
                        )
                        :
                        (
                            <Button className={'btn btn-success'} onClick={UpdateBuildingAndSystem}>Update Readings</Button>
                        )
                }
            </Form>

        </div>
    )
}

export default QuarterlyInspectionSystemUpdate

